import $http from '@/api/index'
/**
 * @description 新增群组 Id Name GroupType CreateUser CreateUserName TaskId NickName
 * @constructor
 */
function addCluster(params) {
	let getUrl = {
		method: 'POST',
		url: 'group/Add',
		requestType: 5,
	}
	return $http(getUrl, params)
}
/**
 * @description 群组添加成员
 * @constructor
 */
function AddClusterMember(params) {
	let getUrl = {
		method: 'POST',
		url: 'group/AddMember',
		requestType: 5,
	}
	return $http(getUrl, params)
}

/**
 * @description 修改群组
 * @constructor
 */
function updateCluster(params) {
	let getUrl = {
		method: 'POST',
		url: 'group/Update',
		requestType: 5,
	}
	return $http(getUrl, params)
}
/**
 * @description 解散群组 
 * @constructor 
 */
function removerCluster(Id) {
	let getUrl = {
		method: 'POST',
		url: 'group/Remove',
		requestType: 5,
	}
	let params = {
		Id:Id
	}
	return $http(getUrl, params)
}
/**
 * @description 删除群组联系人 GroupId LinkId
 * @constructor 
 */
function reomoveClusterMember(GroupId, LinkId) {
	let getUrl = {
		method: 'POST',
		url: 'group/RemoveMember',
		requestType: 5,
	}
	let params = {
	  "GroupId": GroupId,
	  "LinkId": LinkId,
	  "LinkType": 0,
	  "IsAdmin": 0
	}
	return $http(getUrl, params)
}

function NewGroupId(){
	let getUrl = {
		method: 'GET',
		url: 'group/NewGroupId',
		requestType: 5,
	}
	let params = {
	}
	return $http(getUrl, params)
}
export default {
	addCluster,
	AddClusterMember,
	removerCluster,
	reomoveClusterMember,
	NewGroupId,
	updateCluster
}
